import React from "react";
import { ActionExecuteStartCondition, WorkflowTriggerType } from "../../../../../__generated__/api";
import SettingsContainer from "../../../../../components/theme/settings";
import UserGroups from "../../../../../components/pickers/user-groups/UserGroups";
import Select from "../../../../../components/select/Select";
import FormGroup from "../../../../../components/theme/form-group/FormGroup";
import { PropertiesByTrigger } from "./useGeneralSettingsProperties";
import GeneralDetailsDescription from "./GeneralDetailsDescription";

const EXECUTE_CONDITIONS = [
    {
        value: ActionExecuteStartCondition.AfterStarted,
        label: "Assigned Tickets",
    },
    {
        value: ActionExecuteStartCondition.BeforeOrAfterStarted,
        label: "Any ticket",
    },
];

export default function ActionGeneralDetails({ properties }: { properties: PropertiesByTrigger<WorkflowTriggerType.Action> }) {
    return (
        <SettingsContainer navigation="none">
            <SettingsContainer.Section title="General Details">
                <SettingsContainer.Setting
                    title="Name"
                    description="The name of the action displayed at the top and in the action selection."
                    permissions={[]}
                >
                    <FormGroup
                        type="text"
                        placeholder="Enter Action Name"
                        onChange={evt => properties.name.setValue(evt.target.value)}
                        value={properties.name.value}
                    />
                </SettingsContainer.Setting>
                <SettingsContainer.Setting
                    title="Description"
                    description="The optional description is to help you understand where this
                    action is used. It will never be displayed to the end user."
                    permissions={[]}
                >
                    <GeneralDetailsDescription properties={properties} />
                </SettingsContainer.Setting>

                <SettingsContainer.Setting
                    title="Groups"
                    description="The groups that will be able to use this action."
                    permissions={[]}
                >
                    <UserGroups
                        value={properties.groups.value}
                        onSelected={properties.groups.setValue}
                        isMulti
                    />
                </SettingsContainer.Setting>

                <SettingsContainer.Setting
                    title="Start Condition"
                    description="The condition that will be used to start the action."
                    permissions={[]}
                >
                    <Select
                        options={EXECUTE_CONDITIONS}
                        value={EXECUTE_CONDITIONS.find(condition => condition.value === properties.startCondition.value)}
                        onChange={
                            value => properties.startCondition.setValue(value.value as ActionExecuteStartCondition)
                        }
                    />
                </SettingsContainer.Setting>
            </SettingsContainer.Section>
        </SettingsContainer>
    );
}
